// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps;

export interface AddressesLayoutStyles {
    container?: GridContainerProps;
    leftColumnGridItem?: GridItemProps;
    rightColumnGridItem?: GridItemProps;
    mainContainer?: GridContainerProps;
    leftMainColumnGridItem?: GridItemProps;
    rightMainColumnGridItem?: GridItemProps;
}

export const styles: AddressesLayoutStyles = {
    container: {
        offsetCss: css`
            align-items: baseline;
        `,
    },
    leftColumnGridItem: {
        width: [10, 10, 9, 9, 9],
        align: "top",
    },
    rightColumnGridItem: {
        width: [2, 2, 3, 3, 3],
        align: "top",
    },
    leftMainColumnGridItem: {
        width: [12, 12, 4, 4, 4],
        align: "top",
    },
    rightMainColumnGridItem: {
        width: [12, 12, 8, 8, 8],
        align: "top",
    },
};

const AddressesLayout: React.FC<Props> = ({ id }) => {
    return (
        <>
            <GridContainer {...styles.container}>
                <GridItem {...styles.leftColumnGridItem}>
                    <Zone contentId={id} zoneName="Content0" />
                </GridItem>
                <GridItem {...styles.rightColumnGridItem}>
                    <Zone contentId={id} zoneName="Content1" />
                </GridItem>
            </GridContainer>

            <GridContainer {...styles.mainContainer}>
                <GridItem {...styles.leftMainColumnGridItem}>
                    <Zone contentId={id} zoneName="Content2" />
                </GridItem>
                <GridItem {...styles.rightMainColumnGridItem}>
                    <Zone contentId={id} zoneName="Content3" />
                </GridItem>
            </GridContainer>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: AddressesLayout,
    definition: {
        displayName: "Addresses Layout",
        group: "XNGAGE" as any,
        allowedContexts: ["AddressesPage"],
    },
};

export default widgetModule;
